import { createRouter, createWebHistory } from 'vue-router'
import { useCookies } from 'vue3-cookies'; // Импортируем VueCookies

import store from '../store'

import Home from '../page/index.vue'
import Blocks from '../page/blocks.vue'
import Miners from '../page/miners.vue'
import Help from '../page/help.vue'
import Account from '../page/account.vue'
import NotFound from '../page/notFound.vue'
import TestPage from '../page/TestPage.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/blocks',
    name: 'blocks',
    component: Blocks
  },
  {
    path: '/miners',
    name: 'miners',
    component: Miners,
  },
  {
    path: '/help',
    name: 'help',
    component: Help
  },
  {
    path: '/account/:login',
    name: 'account',
    component: Account,
  },
  {
    path: '/account/:login/:page',
    component: Account,
    children: [
      {
        path: '',
      },
      {
        path: 'rewards',
      },
      {
        path: 'payouts',
      },
    ],
  },
  {
    path: '/test',
    name: 'Test',
    component: TestPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/404',
    component: NotFound,
  },
  {
    path: "/:catchAll(.*)",
    redirect: '/404',
  },
]

const router = createRouter({
  routes,
  history: createWebHistory(),
})

const { cookies } = useCookies();

router.beforeEach(async (to, from, next) => {
  // Проверка наличия куки isAuthenticated и текущего состояния авторизации в Vuex store
  const isAuthenticatedCookie = cookies.get('isAuthenticated') === 'true';

  try {
    // Если кука isAuthenticated присутствует, проверяем валидность токена
    if (isAuthenticatedCookie) {
      await store.dispatch('verifyToken');
    } else {
      // Если куки нет, сбрасываем авторизацию в Vuex и редирект на страницу логина
      store.commit('SET_AUTH', false);
      store.commit('SET_USER_EMAIL', null);
    }
  } catch (error) {
    // Если верификация не прошла, сбрасываем авторизацию и редиректим на логин
    store.commit('SET_AUTH', false);
    store.commit('SET_USER_EMAIL', null);
    await store.commit("SET_ERROR", error);
  }

  // Проверяем, если маршрут требует авторизации
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Если пользователь авторизован, продолжаем
    if (store.getters.isAuthenticated) {
      next();
    } else {
      // Если нет — редирект на страницу логина
      next({ name: 'Login' });
    }
  } else {
    next(); // Если маршрут не требует авторизации, продолжаем
  }
});


export default router